import React from 'react'

const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
}

const cb = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('fadeIn');
        }
    });
}

export class WorkItem extends React.Component {

    constructor(props) {
        super(props)
        this.myRef = React.createRef();
        this.state = {
            observer: new IntersectionObserver(cb, options)
        }
    }

    componentDidMount() {
        this.state.observer.observe(this.refs['work-item'])
    }

    componentWillUnmount() {
        this.state.observer.disconnect();
    }


    render() {
        return <div ref='work-item' className="work-item" >
            <a rel="noopener noreferrer" target="_blank" href={this.props.url}>
                <h3>{this.props.title}</h3>
                <p>{this.props.tech && this.props.tech.join(', ')}</p>
                <h4>{this.props.type}</h4>
            </a>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/Pages/Components/WorkItem.js